import * as ActionTypes from './actionTypes';
import apiActionCreator from '../../common/service/api/actionCreator';
import {buildErrorMessage} from '../../common/util/errorUtils';
import {getUrlParameters} from '../../common/util/urlParameters';

export const getPriceFactorsList = (urlParameters = {}) => apiActionCreator({
  'endpoint': `/price-factors/${getUrlParameters(urlParameters)}`,
  'authenticated': true,
  'types': [
    ActionTypes.GET_PRICE_FACTORS_INFO_REQUEST,
    ActionTypes.GET_PRICE_FACTORS_INFO_SUCCESS,
    [
      ActionTypes.GET_PRICE_FACTORS_INFO_FAILED,
      (error) => buildErrorMessage(error),
    ],
  ],
  'microservice': 'part',
  'method': 'GET',
});

export const downloadPriceFactorsList = (urlParameters = {}) => apiActionCreator({
  'endpoint': `/price-factors/excel${getUrlParameters(urlParameters)}`,
  'authenticated': true,
  'types': [
    ActionTypes.DOWNLOAD_PRICE_FACTOR_LIST_REQUEST,
    ActionTypes.DOWNLOAD_PRICE_FACTOR_LIST_SUCCESS,
    [
      ActionTypes.DOWNLOAD_PRICE_FACTOR_LIST_FAILED,
      (error) => buildErrorMessage(error),
    ],
  ],
  'microservice': 'part',
  'method': 'GET',
});

export const clearPriceFactorsListUrl = () => ({
  'type': ActionTypes.CLEAR_PRICE_FACTORS_LIST_URL,
});

export const clearPriceFactorsList = () => ({
  'type': ActionTypes.CLEAR_PRICE_FACTORS_LIST,
});

export const changePriceFactorsListPage = (newPage) => ({
  'type': ActionTypes.CHANGE_PRICE_FACTORS_PAGE,
  'payload': newPage,
});

export const changePriceFactorsListPageSize = (pageSize) => ({
  'type': ActionTypes.CHANGE_PRICE_FACTORS_PAGE_SIZE,
  'payload': pageSize,
});
